export enum VinnovaStatus {
  New = -1,
  Unverified,
  Verified,
  Blocked,
  Obsolete,
}
